angular.module('picmonicng').directive('focusSelectAll', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        element.bind('focus', function () {
          $timeout(function () {
            element[0].select();
          });
        });
      },
    };
  },
]);
